import { Checkbox } from '@cian/ui-kit';
import { EFacilityType } from '../../../../../../../packages/JsonQuery';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectFacilitiesFilter } from 'shared/selectors/advancedFilters';
import { formatToJsonQueryTermsValue } from 'shared/utils/jsonQuery';
import { InlineFiltersGrid } from 'shared/components/InlineFiltersGrid';

export const FacilitiesContainer: FC = () => {
  const { label, value, options } = useSelector(selectFacilitiesFilter);

  const onChange = useFilterChangeCallback();

  const handleFacilitiesChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, facility: EFacilityType) => {
      const { checked } = event.target;
      let nextValue: EFacilityType[] = value || [];

      switch (true) {
        case facility === EFacilityType.WithoutFurniture && checked:
          nextValue = nextValue.filter(v => ![EFacilityType.RoomFurniture, EFacilityType.KitchenFurniture].includes(v));
          nextValue.push(facility);
          break;
        case [EFacilityType.RoomFurniture, EFacilityType.KitchenFurniture].includes(facility) && checked:
          nextValue = nextValue.filter(v => v !== EFacilityType.WithoutFurniture);
          nextValue.push(facility);
          break;
        case checked:
          nextValue.push(facility);
          break;
        default:
          nextValue = nextValue.filter(v => v !== facility);
      }

      onChange({ action: 'setFacilityTypes', arguments: [formatToJsonQueryTermsValue(nextValue)] });
    },
    [value, onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFiltersGrid>
        {options.map(facility => (
          <Checkbox
            key={facility.value}
            label={facility.label}
            checked={value ? value.includes(facility.value) : false}
            onChange={event => handleFacilitiesChange(event, facility.value)}
          />
        ))}
      </InlineFiltersGrid>
    </AdvancedFilterRow>
  );
};
